import React,{ useEffect , useState } from "react";
import logo from "../../assets/img/Logo/logo.svg";
import user from "../../assets/img/icons/user.svg";
import shoppingCard from "../../assets/img/icons/shopping-bag.svg";
import arrow from "../../assets/img/icons/arrow-down.svg";
import login from "../../assets/img/icons/login.svg";
import notification from "../../assets/img/icons/notification-bing.svg";
import SearchInput from "../shared/SearchInput";
import IconBox from "../shared/IconBox";
import { useAuth } from "../../context/authContext";
import { Link, useNavigate } from "react-router-dom";
import UserDropbox from "./UserDropbox";
import Pusher from 'pusher-js';
import Echo from 'laravel-echo';
import { API_URL } from "../../constants";
import Cookies from "js-cookie";
import { useUserInfo } from '../../context/UserContext';
import HamberburgerMenu from "./HamberburgerMenu";
import PersianNumber from "../shared/PersianNumber";
import useFetch from "../../hooks/useAxios";
import NotifDropBox from "./NotifDropBox";
import toast from "react-hot-toast";

const Menu = () => {
  const { token } = useAuth();
  const navigate = useNavigate();

  window.Pusher = Pusher;
  // window.Pusher.logToConsole = true;

  window.Echo = new Echo({
      broadcaster: 'pusher',
      key: 'b0186db0f714b3c62cad',
      cluster: 'mt1',
      encrypted:false,
      authEndpoint: API_URL + '/api/broadcasting/auth',
      auth: {
        headers: {
            Authorization: 'Bearer ' + Cookies.get("token")
        },
      }
  });
  const [notif, setnotif] = useState([])
  const [newnotif, setNewnotif] = useState(false)
  const fetchnotif = useFetch({
    method: "get",
    url: "api/notifications",
    noHeader: false,
    trigger: true,
    argFunc: res => {
      setnotif(res.data)
      
    }
  });
  const {userinfo} = useUserInfo()
  if (userinfo.data) {

    window.Echo.private('notification.' + userinfo.data.user.id)
      .listen('.notification.send', (e) => {
          console.log("e.pusher",e)
          setNewnotif(true)
          setnotif(prev=>[...prev,e])
          toast.success("شما اعلان جدید دارید.")
    });
  }
 

  return (
    <div className="Menu">
      <div className="Menu-container">
        <div className="flex justify-between mt-[17px]  ">
          <img src={logo} alt="logo" />
          <SearchInput />
          {!token
            ? <div className="flex  items-center ">
                <Link to="/register">
                  {" "}<div className="common-bg px-[24px] py-[24px] cursor-pointer  flex items-center">
                    <img src={login} className="w-[21px]" alt="" />

                    <div className=" mr-[10px] font-[500] text-[18px] text-[#292D32]">
                      ورود / ثبت نام
                    </div>
                  </div>
                </Link>
                <div className=" cursor-pointer  border-r-[1px] border-solid border-[#D2D7D9] pr-[28px] mr-[24px]">
                  <img src={shoppingCard} alt="" />
                </div>
              </div>
            : <div className="flex  items-center  ">
                <div className="flex userarrow px-[27px] ml-[27px] border-l-[1px] border-solid border-[#D2D7D9] relative">
                  <img src={user} className="ml-[13px] w-[24px]" alt="user" />
                 <img
                  
                  src={arrow}
                  alt="arrow"
                  className="w-[10px]   cursor-pointer"
                />
                
   
                  <UserDropbox />
                </div>
                <div className="common-bg notif-row flex items-center p-[13px] relative cursor-pointer">
                <div className="relative">
                <img
                    src={notification}
                    alt="notification"
                    className="w-[21.21px]"
                  />
                  {
                  newnotif && <div className="red-dot" />
                }
                </div>
                  <div className="ml-[27px] mr-[14px] font-bold text-[18px]">
                    اعلانات شما
                  </div>
                  <IconBox smallxss white>
                   <PersianNumber number={notif.length} />
                  </IconBox>
                  <NotifDropBox setNewnotif={setNewnotif} list={notif}/>
                </div>
              </div>}
        </div>
      </div>
    </div>
  );
};

export default Menu;
